module.exports = "/assets/_next/static/images/incomplete-sorting-cb5bece4313d7bc51e5cc143222d72bb.png";